import Accordion from "Componentes/Accordion";
import { Col, Container, Row } from "react-bootstrap";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import { Tasks } from "./Tasks";

const GettingStarted: React.FC<RouteProps> = () => {
  return (
    <Container>
      <Row className='justify-content-center py-3'>
        <Col xs={12}>
          <h1>Guía de inicio rápido</h1>
          <p>
            Bienvenido al equipo de desarrollo de crombie! Para que puedas
            empezar a trabajar en proyectos lo antes posible, diseñamos esta
            guía rapida en la que vas a tener que realizar varias de las tareas
            habituales de un desarrollador en Crombie DevTeam sobre este mismo
            repositorio.
          </p>
          <p>
            Si bien vas a econtrar contenido sobre los procesos y estandares
            utilizados en la empresa en este repositorio, te invitamos a que
            recurras a <a href='https://www.google.com/'>google</a>,{" "}
            <a href='https://es.stackoverflow.com/'>stack overflow</a>, y las
            documentaciones oficiales de las tecnologías que vas a necesitar
            para realizar las tareas que están en esta página. (
            <a href='https://es.reactjs.org/'>react</a>,{" "}
            <a href='https://getbootstrap.com/'>bootstrap</a>)
          </p>
          <div className='text-center'>
            <h2>Tareas a realizar</h2>
          </div>
          <div>
            <Accordion questions={Tasks} />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default new Content({
  Component: GettingStarted,
  title: "Comenzando",
  route: "getting-started",
  tags: ["empezar", "empezando", "trainee", "entrenamiento"]
});
